<script setup>

</script>

<template>
  <div @click="$router.go(-1)" class="goback flex items-center">
    <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" fill="none">
      <path d="M36.3501 45.1578L24.7759 33.5836C24.3854 33.1931 24.3854 32.5599 24.7759 32.1694L36.3501 20.5952" stroke="#01386E" stroke-width="5" stroke-linecap="round"/>
    </svg>
    <p>Back</p>
  </div>
</template>

<style scoped lang="scss">
.goback {
  cursor: pointer;
  transition: all .4s ease;
  p {
    margin-left: -10px;
  }
  &:hover {
    opacity: 0.7;
  }
}
</style>